import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../api';
import { useLanguage } from '../LanguageContext';
import './PageShell.css';
import './Marketplace.css';

export default function PublishProduct() {
  const { language } = useLanguage();
  const text = language === 'zh' ? {
    kicker: '发布二手商品',
    title: '让闲置物品在社区继续流转',
    done: '商品已提交审核',
    doneText: '审核通过后将在二手商品页展示。',
    back: '返回二手商品',
    productTitle: '商品标题 *',
    titlePlaceholder: '如：九成新人体工学办公椅',
    category: '分类 *',
    categoryPlaceholder: '如：数码电子、家具家居',
    price: '价格 *',
    pricePlaceholder: '如：¥680',
    condition: '成色 *',
    conditionPlaceholder: '如：九成新',
    area: '交易地区 *',
    areaPlaceholder: '如：西湖区',
    description: '商品描述 *',
    descriptionPlaceholder: '描述使用情况、配件、瑕疵、是否可议价和交易方式',
    submitting: '提交中...',
    submit: '提交审核',
    failed: '提交失败，请稍后再试',
    noticeTitle: '发布须知',
    notice: '请如实描述成色和瑕疵。违禁品、虚假价格、站外引流和诈骗内容会被下架或处罚。',
  } : {
    kicker: 'Post secondhand item',
    title: 'Let idle items circulate in the community',
    done: 'Item submitted for review',
    doneText: 'After approval, it will appear on the secondhand marketplace.',
    back: 'Back to secondhand',
    productTitle: 'Item title *',
    titlePlaceholder: 'Example: Ergonomic office chair in great condition',
    category: 'Category *',
    categoryPlaceholder: 'Example: Electronics, furniture',
    price: 'Price *',
    pricePlaceholder: 'Example: ¥680',
    condition: 'Condition *',
    conditionPlaceholder: 'Example: Like new',
    area: 'Trading area *',
    areaPlaceholder: 'Example: Xihu District',
    description: 'Item description *',
    descriptionPlaceholder: 'Describe usage, accessories, defects, negotiability, and trade method',
    submitting: 'Submitting...',
    submit: 'Submit for review',
    failed: 'Submission failed. Please try again later.',
    noticeTitle: 'Posting notice',
    notice: 'Describe condition and defects honestly. Prohibited goods, false prices, off-platform diversion, and fraud will be removed or penalized.',
  };
  const navigate = useNavigate();
  const [done, setDone] = useState(false);
  const [form, setForm] = useState({ title: '', category: '', price: '', condition: '', area: '', description: '' });
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState('');

  const set = key => e => setForm(f => ({ ...f, [key]: e.target.value }));
  const submit = async e => {
    e.preventDefault();
    setError('');
    setSubmitting(true);
    try {
      await api.post('/marketplace/products', form);
      setDone(true);
    } catch (err) {
      setError(err.response?.data?.error || text.failed);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="market-page page-shell-page">
      <div className="container publish-wrap">
        <div className="market-kicker">{text.kicker}</div>
        <h1 className="detail-title">{text.title}</h1>
        <div className="publish-layout">
          <div className="detail-card">
            {done ? (
              <div>
                <h2>{text.done}</h2>
                <p className="card-muted" style={{ margin: '10px 0 18px' }}>{text.doneText}</p>
                <button className="btn btn-primary" onClick={() => navigate('/secondhand')}>{text.back}</button>
              </div>
            ) : (
              <form onSubmit={submit}>
                {error && <div className="form-error">{error}</div>}
                <div className="form-group"><label>{text.productTitle}</label><input required value={form.title} onChange={set('title')} placeholder={text.titlePlaceholder} /></div>
                <div className="grid-2">
                  <div className="form-group"><label>{text.category}</label><input required value={form.category} onChange={set('category')} placeholder={text.categoryPlaceholder} /></div>
                  <div className="form-group"><label>{text.price}</label><input required value={form.price} onChange={set('price')} placeholder={text.pricePlaceholder} /></div>
                </div>
                <div className="grid-2">
                  <div className="form-group"><label>{text.condition}</label><input required value={form.condition} onChange={set('condition')} placeholder={text.conditionPlaceholder} /></div>
                  <div className="form-group"><label>{text.area}</label><input required value={form.area} onChange={set('area')} placeholder={text.areaPlaceholder} /></div>
                </div>
                <div className="form-group"><label>{text.description}</label><textarea required value={form.description} onChange={set('description')} placeholder={text.descriptionPlaceholder} /></div>
                <button className="btn btn-primary" type="submit" disabled={submitting}>{submitting ? text.submitting : text.submit}</button>
              </form>
            )}
          </div>
          <aside className="detail-card">
            <h2>{text.noticeTitle}</h2>
            <p className="form-note">{text.notice}</p>
          </aside>
        </div>
      </div>
    </div>
  );
}
